// src/hooks/useFirebaseMessaging.js
import { useEffect } from 'react';
import { messaging, onMessage } from 'lib/firebase';
import { useNotificationStore } from 'stores/notifications';

export const useFirebaseMessaging = () => {
  const addNotification = useNotificationStore((state) => state.addNotification);

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      const { title, body } = payload.notification;
      addNotification({ title, body });
    });

    return () => unsubscribe();
  }, [addNotification]);
};
